import React from 'react';
import '../myutils';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import AppBar from '@material-ui/core/AppBar';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FilterListIcon from '@material-ui/icons/FilterList';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import { translate } from 'react-admin';
import moment from 'moment';
import HangUpButton from '../buttons/HangUpButton';
import TransferButton from '../buttons/TransferButton';
import PickUpButton from '../buttons/PickUpButton';
import { configAPI } from '../config'
import CallEnd from '@material-ui/icons/CallEnd';
import {Fragment} from 'react';

function desc(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getSorting(order, orderBy) {
  return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const LabelTag = translate(({ label, translate }) => (
    <span>{translate(label)}</span>
));

class EnhancedTableHead extends React.Component {
  createSortHandler = property => event => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount } = this.props;
    const rows = [
        { id: 'id', numeric: false, disablePadding: true, label: ('resources.Softphone.id') },
        { id: 'did', numeric: true, disablePadding: false, label: ('resources.Softphone.did') },
        { id: 'callerIdNum', numeric: true, disablePadding: false, label: ('resources.Softphone.callerIdNum') },
        { id: 'transferFrom', numeric: false, disablePadding: false, label: ('resources.Softphone.transferFrom') },
        { id: 'path', numeric: false, disablePadding: false, label: ('resources.Softphone.path') },
        { id: 'duration', numeric: true, disablePadding: false, label: ('resources.Softphone.duration') },
        { id: 'hangup', numeric: false, disablePadding: false, label: ('resources.Softphone.hangup') },
        { id: 'pickup', numeric: false, disablePadding: false, label: ('resources.Softphone.pickup') },
        { id: 'transfer', numeric: false, disablePadding: false, label: ('resources.Softphone.transfer') },
    ];
   
    return (
      <TableHead>
        <TableRow>
          <TableCell padding="checkbox">
            <Checkbox
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={numSelected === rowCount}
              onChange={onSelectAllClick}
            />
          </TableCell>
          {rows.map(row => {
            return (
              <TableCell
                key={row.id}
                numeric={row.numeric}
                padding={row.disablePadding ? 'none' : 'default'}
                sortDirection={orderBy === row.id ? order : false}
              >
                <Tooltip
                  title="Sort"
                  placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                  enterDelay={300}
                >
                  <TableSortLabel
                    active={orderBy === row.id}
                    direction={order}
                    onClick={this.createSortHandler(row.id)}
                  >
                    <LabelTag label={row.label}/>
                  </TableSortLabel>
                </Tooltip>
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  translate: PropTypes.func
};

const toolbarStyles = theme => ({
  root: {
    paddingRight: theme.spacing.unit,
  },
  highlight:
    theme.palette.type === 'light'
      ? {
          color: theme.palette.secondary.main,
          backgroundColor: lighten(theme.palette.secondary.light, 0.85),
        }
      : {
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.secondary.dark,
        },
  spacer: {
    flex: '1 1 100%',
  },
  actions: {
    color: theme.palette.text.secondary,
    flex: '0 0 auto',
  },
  title: {
    flex: '0 0 auto',
  },
});

let EnhancedTableToolbar = props => {
  const { numSelected, classes } = props;
  if (numSelected>0){
    var ids = '';
    props.selected.forEach((element, index) => {
      ids+=element+':';
    });
    sessionStorage.setItem('selectedIds',ids);
}
  return (
    <Toolbar
      className={classNames(classes.root, {
        [classes.highlight]: numSelected > 0,
      })}
    >
      <div className={classes.title}>
        {numSelected > 0 ? (
          <Typography color="inherit" variant="subheading">
            {numSelected} selected
          </Typography>
        ) : (
          <Typography variant="title" id="tableTitle">
            <LabelTag label={'resources.Softphone.incomingCalls'}/>
          </Typography>
        )}
      </div>
      <div className={classes.spacer} />
      <div className={classes.actions}>
        {numSelected > 0 ? (<Fragment>
          <Tooltip title="TransferCall">
            {/* <IconButton aria-label="TransferCall"> */}
              <TransferButton />
            {/* </IconButton> */}
          </Tooltip>
          <Tooltip title="Delete">
            <IconButton aria-label="Delete">
              <CallEnd onClick={()=>{
                  if (props.selected.length>0){
                      var ids = '';
                      var data = new FormData();
                      data.append("token", sessionStorage.B.encodeDecode());
                      data.append("action", "hangup");
                      props.selected.forEach((element, index) => {
                        ids+=element+':';
                      });
                      data.append("ids", ids);

                      return fetch(configAPI.api.prod + 'CallAction', {
                        method: "POST",
                        body: data
                    });
                  }
                }}/>
            </IconButton>
          </Tooltip>
          </ Fragment>
        ) : (
          <Tooltip title="Filter list">
            <IconButton aria-label="Filter list">
              <FilterListIcon />
            </IconButton>
          </Tooltip>
        )}
      </div>
    </Toolbar>
  );
};

EnhancedTableToolbar.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
};

EnhancedTableToolbar = withStyles(toolbarStyles)(EnhancedTableToolbar);

const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
  },
});

class IncomingCalls extends React.Component {

    componentDidMount() {
        this.timer = setInterval(()=> this.getItems(), 3000);
    }
    componentWillUnmount() {
        clearInterval(this.timer);
        this.timer = null;
    }

    getItems() {
        this.setState({data: JSON.parse(sessionStorage.getItem('incomingCalls'))});
    }

  state = {
    order: 'asc',
    orderBy: 'id',
    selected: [],
    data: JSON.parse(sessionStorage.getItem('incomingCalls')),
    page: 0,
    rowsPerPage: 10,
    filter: '',
    filterField: ''
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';

    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }

    this.setState({ order, orderBy });
  };

  handleSelectAllClick = (event, checked) => {
    if (checked) {
      this.setState(state => ({ selected: state.data.map(n => n.id) }));
      return;
    }
    this.setState({ selected: [] });
  };

  handleClick = (event, id) => {
    const { selected } = this.state;
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    this.setState({ selected: newSelected });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value });
  };

  handleFilterChange = (e) => {
    let filter = e.target.value;
    this.setState({ filter: filter });
  };

  handleFilterFieldChange = event => {
    this.setState({ filterField: event.target.value });
  };

  isSelected = id => this.state.selected.indexOf(id) !== -1;

  render() {
    const { classes, translate } = this.props;
    const props = this.props;
    const { data, order, orderBy, selected, rowsPerPage, page } = this.state;
    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    return (
      <>
        <AppBar position="static" color="default" elevation={1}>
          <Toolbar>
            <Typography variant="title" color="inherit" style={{ width: '80%', float: "right" }}>
              {translate('resources.Softphone.name')}
            </Typography>
            <Typography variant="subtitle1" color="inherit" style={{ width: '20%', float: "left" }}>
              {translate('trans.now_listening')}:
              {(data[0].duration!==0)?(data.length):'0'}
            </Typography>
          </Toolbar>
        </AppBar>
        <Paper className={classes.root}>
          <EnhancedTableToolbar numSelected={selected.length} selected={selected}/>
          <div className={classes.tableWrapper}>
          <label variant="subtitle1" color="inherit" style={{padding:'10px'}}>{translate('trans.filterValue')}</label>
          <TextField onChange={(e) => this.handleFilterChange(e)} onClick={(e) => e.stopPropagation()} />
          <label variant="subtitle1" color="inherit" style={{padding:'10px'}}>{translate('trans.filterField')}</label>
          <Select
            value={this.state.filterField}
            onChange={this.handleFilterFieldChange}
            // name="field"
            displayEmpty
            name="fieldss"
          >
            <MenuItem value={'did'}>{translate('trans.filterFieldDid')}</MenuItem>
            <MenuItem value={'callerIdNum'}>{translate('trans.filterFieldCallerIdNum')}</MenuItem>
            <MenuItem value={'transferFrom'}>{translate('trans.filterFieldTransferFrom')}</MenuItem>
            <MenuItem value={'path'}>{translate('trans.filterFieldPath')}</MenuItem>
          </Select>
          <br/><br/><br/>

            <Table className={classes.table} aria-labelledby="tableTitle">
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                onSelectAllClick={this.handleSelectAllClick}
                onRequestSort={this.handleRequestSort}
                rowCount={data.length}
              />
              <TableBody>
                {data
                  .sort(getSorting(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((n, index) => {
                    // .map(n => {
                    const isSelected = this.isSelected(n.id);
                    if (n[this.state.filterField]===this.state.filter || this.state.filter == '') return (
                      <TableRow
                        hover
                        onClick={event => this.handleClick(event, n.id)}
                        role="checkbox"
                        aria-checked={isSelected}
                        tabIndex={-1}
                        key={n.id}
                        selected={isSelected}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox checked={isSelected} />
                        </TableCell>
                        <TableCell numeric component="th" scope="row" padding="none">
                          {index}
                        </TableCell>
                        <TableCell >{n.did}</TableCell>
                        <TableCell >{n.callerIdNum}</TableCell>
                        <TableCell >{n.transferFrom}</TableCell>
                        <TableCell >{n.path}</TableCell>
                        <TableCell numeric><span>{moment.utc(n.duration * 1000).format('HH:mm:ss')}</span></TableCell>
                        <TableCell ><HangUpButton call={n} ></HangUpButton></TableCell>
                        <TableCell ><PickUpButton ></PickUpButton></TableCell>
                        <TableCell ><TransferButton call={n} {...props} ></TransferButton></TableCell>

                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 49 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </div>
          <TablePagination
            component="div"
            count={data.length}
            rowsPerPage={rowsPerPage}
            page={page}
            backIconButtonProps={{
              'aria-label': 'Previous Page',
            }}
            nextIconButtonProps={{
              'aria-label': 'Next Page',
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </Paper>
      </>
    );
  }
}

IncomingCalls.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(translate(IncomingCalls));
// export default connect(null, {
//     push: pushAction,
// })(withStyles(styles)(translate(IncomingCalls)));
